module.exports = __webpack_public_path__ + "img/login_min_left.ff247fc9.png";